// extracted by mini-css-extract-plugin
module.exports = {"root":"product-gallery_root__2qFmF","image":"product-gallery_image__3Vduc"};